// extracted by mini-css-extract-plugin
export default {"link":"WMZhG0K0q1"};